import { createContext } from 'react';

import type { RolesContextValue } from './rolesContextTypes';

export const RolesContext = createContext<RolesContextValue | null>(null);
